import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from "./jsx.js";
export const AsyncContext = createContext({
    fetchContent: (url) => fetch(url).then((b) => b.text()),
    runSSE: false,
});
export function createAsyncContextProvider({ fetchContent, runSSE, }) {
    const promises = [];
    const wrappedFetchContent = (url) => {
        const promise = fetchContent(url);
        promises.push(promise);
        return promise;
    };
    const AsyncContextProvider = ({ children }) => {
        return (_jsx(AsyncContext.Provider, { value: { fetchContent: wrappedFetchContent, runSSE }, children: children }));
    };
    return {
        AsyncContextProvider,
        all: () => Promise.all(promises),
        skipSSE: () => (runSSE = false),
    };
}
function useSSE(effect, deps) {
    useEffect(effect, deps);
    const { runSSE } = useContext(AsyncContext);
    // if runSSE, we call the given effect. That should be used on SSR
    if (runSSE) {
        effect();
    }
}
const cache = new Map();
const loading = { loading: true };
export function useFetch(url) {
    const { fetchContent } = useContext(AsyncContext);
    const [_, setLoading] = useState(true);
    useSSE(() => {
        if (cache.has(url)) {
            return;
        }
        cache.set(url, loading);
        fetchContent(url).then((content) => {
            cache.set(url, { content, loading: false });
            setLoading(false);
        });
    }, [url]);
    return cache.get(url) || loading;
}
